webpackJsonp([15074322987140],{

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SheShines = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(18);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(15);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(13);
	
	__webpack_require__(12);
	
	var _reactLinkedinInsight = __webpack_require__(16);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	__webpack_require__(35);
	
	__webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var duration = 400;
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SheShines = exports.SheShines = function (_React$Component) {
	  _inherits(SheShines, _React$Component);
	
	  function SheShines(args) {
	    _classCallCheck(this, SheShines);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	
	    return _this;
	  }
	
	  SheShines.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  SheShines.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  SheShines.prototype.render = function render() {
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "Training Sessions: Winpe PEVC Career Portal",
	        image: "https://winpeforum.com/assets/ignite/cover.png",
	        description: "CV In, Stress Out: Let's Ignite Up Your PEVC Future. Maximize Impact, Harness The Power of PEVC Insights and Accelerate Your Job Search with Our Panel of Experts.",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "container ", style: { paddingTop: '20px' } },
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          " ",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "h1",
	            { className: " title", style: { color: '#bf2026', fontWeight: '700', textAlign: 'left' } },
	            "TRAINING SESSIONS"
	          ),
	          _react2.default.createElement("br", null),
	          " ",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-4 col-md-4 col-sm-12" },
	              _react2.default.createElement("iframe", { width: "100%", height: "195", src: "https://www.youtube.com/embed/yXR7r8hm2cw?si=MYF-4yKrM0KyANih", title: "YouTube video player", frameborder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share", referrerpolicy: "strict-origin-when-cross-origin", allowfullscreen: true })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-4 col-md-4 col-sm-12" },
	              _react2.default.createElement("iframe", { width: "100%", height: "195", src: "https://www.youtube.com/embed/qjrDgcACrc0?si=HYMnNlO_XYpqfyWr", title: "YouTube video player", frameborder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share", referrerpolicy: "strict-origin-when-cross-origin", allowfullscreen: true })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-4 col-md-4 col-sm-12" },
	              _react2.default.createElement("iframe", { width: "100%", height: "195", src: "https://www.youtube.com/embed/8xO6zcmYBAw?si=34NVwyNwgqWxV-nO", title: "YouTube video player", frameborder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share", referrerpolicy: "strict-origin-when-cross-origin", allowfullscreen: true })
	            )
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-4 col-md-4 col-sm-12" },
	              _react2.default.createElement("iframe", { width: "100%", height: "195", src: "https://www.youtube.com/embed/8hlayYZ_fH8?si=dQBRyIL-kykMEKF6", title: "YouTube video player", frameborder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share", referrerpolicy: "strict-origin-when-cross-origin", allowfullscreen: true })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-4 col-md-4 col-sm-12" },
	              _react2.default.createElement("iframe", { width: "100%", height: "195", src: "https://www.youtube.com/embed/2E65yZDHqWY?si=YholVRwlbzKKXqAs", title: "YouTube video player", frameborder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share", referrerpolicy: "strict-origin-when-cross-origin", allowfullscreen: true })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-4 col-md-4 col-sm-12" },
	              _react2.default.createElement("iframe", { width: "100%", height: "195", src: "https://www.youtube.com/embed/3ex8GK7asNg?si=cuiitzZrxTIh0H8N", title: "YouTube video player", frameborder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share", referrerpolicy: "strict-origin-when-cross-origin", allowfullscreen: true })
	            )
	          ),
	          "    ",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-4 col-md-4 col-sm-12" },
	              _react2.default.createElement(
	                "a",
	                { href: "https://winpeforum.com/assets/elements/Impact_of_revised_FDI_Policy_April_2020_Webcast.pdf" },
	                _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/ignite/trainingpdf2.png", alt: "About Image", style: { width: '100%' } })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-4 col-md-4 col-sm-12" },
	              _react2.default.createElement(
	                "a",
	                { href: "https://winpeforum.com/assets/elements/Impact_on_Deals_and_Contracts.pdf" },
	                _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/ignite/trainingpdf1.png", alt: "About Image", style: { width: '100%' } })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null)
	      ),
	      _react2.default.createElement(TeamModal, {
	        show: isShow,
	        onHide: this.togglePopUp,
	        activeItem: this.state.activeItem
	      })
	    );
	  };
	
	  return SheShines;
	}(_react2.default.Component);
	
	SheShines.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SheShines;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-trainings-index-js-724466601a23532cf582.js